var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMtLogoMinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.642 13.791L0 18.211l7.643 4.416 7.64-4.417 7.641-4.419-7.641-4.42-7.64 4.42z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.643 13.79l7.64-4.419V.535L7.643 13.79z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.283.534v8.838l7.641 4.418L15.283.534z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.282 18.21l-7.64 4.418v8.838l7.64-13.257z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.641 31.466v-8.838L0 18.21l7.641 13.257z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.993 2.003c.047 0 .088-.01.125-.029a.212.212 0 00.117-.194.216.216 0 00-.117-.197.266.266 0 00-.125-.029h-.205v.449h.205zm.334.442c0 .01-.004.017-.012.022a.049.049 0 01-.03.008.04.04 0 01-.022-.005.061.061 0 01-.013-.016l-.235-.375h-.227v.358a.04.04 0 01-.01.027c-.007.007-.016.01-.03.01a.04.04 0 01-.027-.01.04.04 0 01-.01-.027v-.92a.04.04 0 01.01-.029.04.04 0 01.028-.01h.244c.061 0 .116.013.164.038a.283.283 0 01.113.107.302.302 0 01.041.157.287.287 0 01-.214.285l.22.351c.006.012.01.022.01.03z",
    fill: "#FFFFFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.975 1.06a.917.917 0 000 1.834.918.918 0 000-1.835zm0 1.893a.977.977 0 010-1.953.976.976 0 010 1.953z",
    fill: "#FFFFFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtLogoMinIcon);
export default __webpack_public_path__ + "static/media/mt-logo-min-icon.c0a03349.svg";
export { ForwardRef as ReactComponent };